import { Button, ButtonVariant, StyledFlex } from '@dreryk/react-components';

import { onlinePaymentsIntegrationTranslationKeys } from '../../translations';

import { OnlinePaymentsIntegrationAd } from './OnlinePaymentsIntegrationAd';
import { StyledAdContainer, StyledButtonContainer } from './OnlinePaymentsIntegrationIntro.styled';

type OnlinePaymentsIntegrationIntroProps = {
   readonly onShowIntegrationForm: VoidFunction;
};

export const OnlinePaymentsIntegrationIntro = (props: OnlinePaymentsIntegrationIntroProps): JSX.Element => {
   return (
      <StyledFlex justifyContent={'space-between'}>
         <StyledButtonContainer direction={'column'} gap={16} justifyContent={'center'} alignItems={'center'}>
            <Button
               variant={ButtonVariant.PRIMARY}
               onClick={props.onShowIntegrationForm}
               label={onlinePaymentsIntegrationTranslationKeys.intro.buttonLabel}
               testId={'button'}
            />
         </StyledButtonContainer>
         <StyledAdContainer>
            <OnlinePaymentsIntegrationAd />
         </StyledAdContainer>
      </StyledFlex>
   );
};
